// Profil-Nachbau F-14 (Bennys Freigabe 14.10.2026, BAU-TEAMS.md 1.1 bis 1.6, PF-805): alle Wörter der Seiten „Teams“, der
// Teamseite und der Seite „Alle Mitglieder“ in den Einstellungen der Firma, wörtlich nach BAU-TEAMS, und die reinen Funktionen
// dazu, ohne React und ohne Anfrage. Prozent mit Bezug („% des Kontingents“, „% des Teamkontingents“), Zahlen de-AT
// („12,5 %“, „unter 1 %“), Datum TT.MM.JJJJ, Monat lang („Jänner“); nie Beträge, nie Euro. Die Fehlersätze stehen gleichlautend
// wie TEAM_FEHLER am Server (backend/src/administration/organization/teams.ts, PF-802); gezeigt wird der Satz der Antwort, diese
// Wörter brauchen nur die Prüfung vor dem Senden und die Zuordnung zum Feld.
// Geprüft in frontend/tests/teams-seiten.test.mjs.
// F-24 (PF-TX-firma-3, SPEC-firma-b.md 7, GRUNDREGELN 2): Unterzeilen höchstens 12 Wörter; was erklärt, steht im Tooltip
// (ohneTeamSatz.tipp, STANDARD_TIPP, kiChampionTipp, kontingentTipp). Geprüft zusätzlich in frontend/tests/f24-teams-vorgaben.test.mjs.
import { prozentAnzeige } from '../billing/prozent';
import { naechsterMonatsBeginn } from '../billing/kontingentMonat';
import { tagText } from '../billing/shared';
import { ALLE_MITGLIEDER_NAME, istReservierterName, TEAM_NAME, type Anteil, type Grenze, type Kandidat, type Modus, type StandardTeam,
  type TeamZeile } from './vertrag';

export const TEAMS_TEXTE = {
  // 1.3 Seite „Teams“
  titel: 'Teams',
  beschreibung: 'Teams fassen Personen zusammen, mit Teamkontingent und KI-Champion.',
  hinzufuegen: 'Team hinzufügen',
  laden: 'Teams werden geladen …',
  erneut: 'Erneut laden',
  // F-21 Sollte 14 (PF-811-b): über Liste und Teamseite in „Sicht wechseln“.
  sichtLesend: 'Sie sehen die Teams dieser Firma in der Sicht: nur lesend.',
  spalten: { team: 'Team', personen: 'Personen', teamAdmins: 'Team-Admins', kiChampion: 'KI-Champion', teamkontingent: 'Teamkontingent',
    diesenMonat: 'Diesen Monat verwendet' },
  standard: 'Standard',
  alle: (anzahl: number) => `alle (${anzahl})`,
  nichtFestgelegt: 'nicht festgelegt',
  kontingentDerFirma: 'Kontingent der Firma',
  ohneTeamkontingent: 'ohne Teamkontingent',
  ohneBezug: 'ohne Bezug',
  leer: 'Noch keine eigenen Teams. Fügen Sie ein Team hinzu, um die Nutzung je Team zu sehen.',
  summe: (prozent: string) => `Alle Teamkontingente zusammen: ${prozent} des Kontingents. Mehr als 100 % ist erlaubt; die Grenze der Firma gilt immer zuerst.`,
  // 1.4 Dialog „Team hinzufügen“
  feldName: 'Name des Teams',
  nameHinweis: '2 bis 60 Zeichen, zum Beispiel „Arbeitsrecht“ oder „Sekretariat“.',
  leerDanach: 'Das Team ist danach leer. Es ändert nichts, bis Sie Personen hinzufügen.',
  abbrechen: 'Abbrechen',
  angelegt: (name: string) => `Team „${name}“ angelegt. Fügen Sie jetzt Personen hinzu.`,
  // 1.5 Teamseite
  alleTeams: 'Alle Teams',
  teamTitel: (name: string) => `Team „${name}“`,
  umbenennen: 'Umbenennen',
  nameSpeichern: 'Name speichern',
  nameGespeichert: 'Der Name ist gespeichert.',
  personen: 'Personen',
  // PF-SL2-cockpit-2: die Tabelle im Abschnitt „Personen“ trägt einen eigenen Namen, sonst hört die Vorlesehilfe zwei Bereiche
  // „Personen“ ineinander.
  personenTabelle: 'Personen im Team',
  kiChampion: 'KI-Champion',
  teamkontingent: 'Teamkontingent',
  teamLoeschen: 'Team löschen',
  personSpalten: { person: 'Person', grenze: 'Persönliche Grenze', teamAdmin: 'Team-Admin' },
  teamAdminMarke: 'Team-Admin',
  weitereAktionen: (name: string) => `Weitere Aktionen für ${name}`,
  personHinzufuegen: 'Person hinzufügen',
  hinzufuegenKnopf: 'Hinzufügen',
  ohneEigenesTeam: 'Ohne eigenes Team',
  ausAnderenTeams: 'Aus anderen Teams',
  alleSchonImTeam: 'Alle Personen Ihrer Firma gehören schon zu einem Team. Personen aus anderen Teams ordnet die Verwaltung Ihrer Firma zu.',
  aufgenommen: (name: string, team: string) => `${name} gehört jetzt zum Team „${team}“.`,
  ausDemTeamNehmen: 'Aus dem Team nehmen',
  herausgenommen: (name: string) => `${name} gehört zu keinem eigenen Team mehr.`,
  zumTeamAdminMachen: 'Zum Team-Admin machen',
  teamAdminGemacht: (name: string, team: string) => `${name} ist jetzt Team-Admin von „${team}“.`,
  teamAdminEntfernen: 'Team-Admin entfernen',
  teamAdminEntfernt: (name: string) => `${name} ist kein Team-Admin mehr.`,
  niemandImTeam: 'Noch niemand in diesem Team. Fügen Sie oben Personen hinzu.',
  // F-24 (E-4): wer die Angaben sieht, bleibt sichtbar (GRUNDREGELN 2); was ein KI-Champion ist, steht im Tooltip am Titel.
  kiChampionErklaerung: 'Die Personen im Team sehen Name und E-Mail-Adresse unter „Mein Team“.',
  kiChampionTipp: 'Die Ansprechperson für Fragen rund um KI und CLAiRIS in diesem Team.',
  niemandFestgelegt: 'Niemand festgelegt',
  speichern: 'Speichern',
  championGespeichert: 'Der KI-Champion ist gespeichert.',
  championAufgehoben: 'Für dieses Team ist kein KI-Champion mehr festgelegt.',
  ohneChampionFirma: (name: string) => `Ohne eigenen KI-Champion sehen die Personen die KI-Verantwortliche oder den KI-Verantwortlichen der Firma: ${name}.`,
  ohneChampionNiemand: 'Ohne KI-Champion sehen die Personen keine Person für Fragen zur KI.',
  // F-24 (E-4): der zweite Satz im Tooltip am Titel.
  kontingentBeschreibung: 'Höchstens so viel vom Kontingent Ihrer Firma darf das Team monatlich verwenden.',
  kontingentTipp: 'Das Kontingent der Firma gilt immer zuerst.',
  // PF-SL1-kreis (Wortliste W1-G07): „Bei erreichtem …“ ist ein altes Wort; wie CostPanel.tsx „Wenn das Kontingent aufgebraucht ist“.
  beiErreichtem: 'Wenn das Teamkontingent aufgebraucht ist',
  modus: { HARD: 'Neue Recherchen sperren', SOFT: 'Weitere Recherchen erlauben' } as Record<Modus, string>,
  aendern: 'Ändern',
  feldTeamkontingent: 'Teamkontingent (% des Kontingents je Monat)',
  teamkontingentHinweis: '0,1 bis 100, eine Nachkommastelle; leer heißt: ohne Teamkontingent.',
  teamkontingentSpeichern: 'Teamkontingent speichern',
  teamkontingentGespeichert: 'Das Teamkontingent ist gespeichert. Es gilt ab sofort.',
  ohneBezugSatz: 'Teamkontingent ohne Bezug: Ihre Firma hat derzeit kein Kontingent.',
  loeschenErklaerung: 'Die Personen bleiben in Ihrer Firma und gehören danach zu keinem eigenen Team.',
  loeschenKnopf: 'Team löschen …',
  geloescht: (name: string) => `Team „${name}“ gelöscht.`,
  nichtMehr: 'Dieses Team gibt es nicht mehr.',
  // 1.6 „Alle Mitglieder“
  kiVerantwortliche: 'KI-Verantwortliche:r der Firma',
  // F-24: „Sie wird in den Firmendaten festgelegt.“ entfällt, der Link „In den Firmendaten ändern“ sagt es (E-4).
  kiVerantwortlicheErklaerung: 'Ansprechperson für alle ohne eigenes Team oder ohne KI-Champion.',
  name: 'Name',
  email: 'E-Mail-Adresse',
  inFirmendatenAendern: 'In den Firmendaten ändern',
  kontingent: 'Kontingent',
  kontingentAlleSatz: `Für „${ALLE_MITGLIEDER_NAME}“ gilt das Kontingent der Firma.`,
  kontingentOeffnen: 'Kontingent öffnen',
  vorgabeTitel: 'Persönliche Grenze für alle ohne eigene Grenze',
  vorgabeWert: (prozent: string) => `Vorgabe der Firma: ${prozent} des Kontingents je Monat`,
  keineVorgabe: 'keine Vorgabe',
  vorgabeAendern: 'Vorgabe ändern',
} as const;

/** Die Fehler am Feld „Name des Teams“ (1.4); TEAM_NAME_VERGEBEN, TEAM_NAME_RESERVIERT und TEAM_GRENZE wie TEAM_FEHLER am Server. */
export const NAME_FEHLER = {
  LAENGE: 'Bitte einen Namen mit 2 bis 60 Zeichen eingeben.',
  TEAM_NAME_VERGEBEN: 'Ein Team mit diesem Namen gibt es schon.',
  TEAM_NAME_RESERVIERT: '„Alle Mitglieder“ ist der Name des Standardteams. Bitte einen anderen Namen wählen.',
  TEAM_GRENZE: 'Ihre Firma hat schon 200 Teams. Bitte zuerst ein Team löschen.',
  STEUERZEICHEN: 'Der Name darf keine Steuer- oder Richtungszeichen enthalten.',
} as const;
/** Codes, deren Satz am Feld „Name des Teams“ steht. */
export const NAME_CODES = ['TEAM_NAME_VERGEBEN', 'TEAM_NAME_RESERVIERT', 'TEAM_GRENZE'] as const;
/** 409 STALE_TEAM, 404 TEAM_NICHT_GEFUNDEN (1.5 „Fehler auf der Seite“). */
export const STALE_TEAM = 'STALE_TEAM';
export const TEAM_NICHT_GEFUNDEN = 'TEAM_NICHT_GEFUNDEN';

// Wie teamName am Server (teamVertrag.ts): kein C0- oder C1-Steuerzeichen, kein Zeilen- oder Absatztrenner, keine Richtungsmarke,
// -einbettung, -überschreibung oder -isolierung und kein einzelnes UTF-16-Surrogat. Nur als \u-Folgen (Trojan Source).
const STEUERZEICHEN = /[\u0000-\u001f\u007f-\u009f\u061c\u200e\u200f\u2028\u2029\u202a-\u202e\u2066-\u2069]/;
const EINZELNES_SURROGAT = /[\ud800-\udbff](?![\udc00-\udfff])|(?<![\ud800-\udbff])[\udc00-\udfff]/;
/** Prüfung des Namens vor dem Senden (1.4); der Server prüft dasselbe noch einmal. */
export function nameFehler(name: string): string | null {
  const wert = name.trim();
  if (wert.length < TEAM_NAME.min || wert.length > TEAM_NAME.max) return NAME_FEHLER.LAENGE;
  if (STEUERZEICHEN.test(wert) || EINZELNES_SURROGAT.test(wert)) return NAME_FEHLER.STEUERZEICHEN;
  return istReservierterName(wert) ? NAME_FEHLER.TEAM_NAME_RESERVIERT : null;
}

// ---- Zahlen und Datum ----

/** „{n} Personen“, „1 Person“, „keine Personen“. */
export const personenText = (anzahl: number) => (anzahl === 0 ? 'keine Personen' : anzahl === 1 ? '1 Person' : `${anzahl} Personen`);
/** Ein Prozentwert de-AT mit „ %“; ein Stand zwischen 0 und 1 heißt „unter 1 %“. */
export const prozent = (wert: number, unterEinem = false) => prozentAnzeige(wert, { unterEinem });
const anteilText = (anteil: Anteil) => prozent(anteil.prozent, anteil.unterEinem);
const WIEN = 'Europe/Vienna';
const MONAT = new Intl.DateTimeFormat('de-AT', { month: 'long', timeZone: WIEN });
/** Der laufende Monat in Wien, lang („Oktober“, „Jänner“). */
export const monatJetzt = (jetzt: Date) => MONAT.format(jetzt);
/** „Beginnt am 1. {nächster Monat} neu“ (Monat des Kontingents in Wien). */
export const beginntNeu = (jetzt: Date) => `Beginnt am 1. ${MONAT.format(naechsterMonatsBeginn(jetzt))} neu`;

// ---- Teamliste (1.3) ----

export type ListenZeile = { id: string; name: string; standard: boolean; personen: string; teamAdmins: string; kiChampion: string; teamkontingent: string;
  diesenMonat: string };
/** Die erste Zeile „Alle Mitglieder“ mit Marke „Standard“. */
export function standardZeile(standard: StandardTeam): ListenZeile {
  return { id: standard.id, name: standard.name, standard: true, personen: TEAMS_TEXTE.alle(standard.personen), teamAdmins: '–',
    kiChampion: standard.kiVerantwortliche?.name || TEAMS_TEXTE.nichtFestgelegt, teamkontingent: TEAMS_TEXTE.kontingentDerFirma,
    diesenMonat: standard.verwendet ? `${anteilText(standard.verwendet)} des Kontingents` : '–' };
}
/** Spalte „Teamkontingent“ einer eigenen Zeile. */
export function teamkontingentText(zeile: Pick<TeamZeile, 'teamkontingentProzent' | 'teamkontingentOhneBezug'>): string {
  if (zeile.teamkontingentOhneBezug) return TEAMS_TEXTE.ohneBezug;
  return zeile.teamkontingentProzent === null ? TEAMS_TEXTE.ohneTeamkontingent : `${prozent(zeile.teamkontingentProzent)} des Kontingents`;
}
/** Spalte „Diesen Monat verwendet“: mit Teamkontingent gegen das Teamkontingent, sonst gegen das Kontingent. */
export function verwendetText(verwendet: TeamZeile['verwendet']): string {
  if (!verwendet) return '–';
  return `${anteilText(verwendet)} ${verwendet.bezug === 'TEAMKONTINGENT' ? 'des Teamkontingents' : 'des Kontingents'}`;
}
/** Eine eigene Zeile; Team-Admins mit Komma oder „–“. */
export function teamZeile(zeile: TeamZeile): ListenZeile {
  return { id: zeile.id, name: zeile.name, standard: false, personen: personenText(zeile.personen), teamAdmins: zeile.teamAdmins.join(', ') || '–',
    kiChampion: zeile.kiChampion?.name || TEAMS_TEXTE.nichtFestgelegt, teamkontingent: teamkontingentText(zeile), diesenMonat: verwendetText(zeile.verwendet) };
}
/** Die eigenen Teams alphabetisch (de). */
export const teamsSortiert = <T extends { name: string }>(teams: readonly T[]) => [...teams].sort((a, b) => a.name.localeCompare(b.name, 'de-AT'));
/** Satz unter der Tabelle: wer zu keinem eigenen Team gehört; bei 0 kein Satz. F-24: was für sie gilt, steht im Tooltip. */
export function ohneTeamSatz(anzahl: number): { satz: string; tipp: string } | null {
  if (anzahl <= 0) return null;
  const wer = anzahl === 1 ? '1 Person gehört' : `${anzahl} Personen gehören`;
  return { satz: `${wer} zu keinem eigenen Team.`, tipp: `Für sie gelten „${ALLE_MITGLIEDER_NAME}“ und das Kontingent der Firma.` };
}
/** Mit costs.read und mindestens einem Teamkontingent die Summe aller Teamkontingente. */
export const summeSatz = (summe: number | null) => (summe === null ? null : TEAMS_TEXTE.summe(prozent(summe)));

// ---- Teamseite (1.5) ----

/** Beschreibung im Kopf: „{n} Personen · angelegt am {TT.MM.JJJJ}“. */
export const kopfBeschreibung = (personen: number, angelegtAm: string) =>
  `${personen === 1 ? '1 Person' : `${personen} Personen`} · angelegt am ${tagText(angelegtAm)}`;

/** Spalte „Persönliche Grenze“; ohne Recht null (die Spalte entfällt). */
export function grenzeText(grenze: Grenze | null): string | null {
  if (!grenze) return null;
  // Ohne Kontingent der Firma gibt es keinen Prozentwert; dann steht nur die Art da.
  const p = grenze.prozent === null ? '' : ` (${prozent(grenze.prozent)})`;
  switch (grenze.art) {
    case 'EIGENE': return `eigene Grenze${p}`;
    case 'VORGABE': return `Vorgabe der Firma${p}`;
    case 'STUFE': return `${grenze.stufe?.name ?? ''}${p}`;
    default: return 'ohne persönliche Grenze';
  }
}

/** Die Auswahl „Person hinzufügen“: zwei Gruppen, je „{Name} ({E-Mail})“, aus anderen Teams mit „, jetzt in „{Team}““. */
export function aufnahmeGruppen(kandidaten: readonly Kandidat[]): { titel: string; optionen: { userId: number; text: string }[] }[] {
  const ohne = kandidaten.filter(k => k.jetzigesTeam === null), andere = kandidaten.filter(k => k.jetzigesTeam !== null);
  return [
    { titel: TEAMS_TEXTE.ohneEigenesTeam, optionen: ohne.map(k => ({ userId: k.userId, text: `${k.name} (${k.email})` })) },
    { titel: TEAMS_TEXTE.ausAnderenTeams, optionen: andere.map(k => ({ userId: k.userId, text: `${k.name} (${k.email}), jetzt in „${k.jetzigesTeam}“` })) },
  ].filter(gruppe => gruppe.optionen.length > 0);
}
/** Satz vor „Hinzufügen“ (gelb), nur bei einem Wechsel aus einem anderen Team; mit dem Zusatz, wenn die Person dort Team-Admin ist. */
export function wechselSatz(kandidat: Pick<Kandidat, 'name' | 'jetzigesTeam' | 'jetztTeamAdmin'> | null | undefined, neu: string): string | null {
  if (!kandidat || kandidat.jetzigesTeam === null) return null;
  const { name, jetzigesTeam: alt } = kandidat;
  const satz = `${name} wechselt aus „${alt}“ in dieses Team. Ab jetzt zählt die Nutzung von ${name} für „${neu}“; was ${name} bisher verwendet hat, bleibt bei „${alt}“.`;
  return kandidat.jetztTeamAdmin ? `${satz} Team-Admin von „${alt}“ ist ${name} danach nicht mehr.` : satz;
}

/** Dialog „Aus dem Team nehmen“: Titel und Sätze; teamAdmin und selbst je mit ihrem Zusatz. */
export function herausnehmenDialog(name: string, team: string, lage: { teamAdmin: boolean; selbst: boolean }): { titel: string; saetze: string[] } {
  return { titel: `${name} aus „${team}“ nehmen?`, saetze: [
    `${name} bleibt in Ihrer Firma und gehört danach zu keinem eigenen Team. Die bisherige Nutzung bleibt beim Team.`,
    ...(lage.teamAdmin ? [`${name} ist danach kein Team-Admin mehr.`] : []),
    ...(lage.selbst ? [`Sie können „${team}“ danach nicht mehr verwalten.`] : []),
  ] };
}
/** Satz (gelb) vor „Zum Team-Admin machen“. Seit Team-Admins Kontingentstufen zuweisen (PF-812, F-15) folgt nach „nehmen“ der Teil
 *  „ihnen eine Kontingentstufe zuweisen“ (BAU-TEAMS.md 1.5; PF-812-nach). */
export const teamAdminMachenSatz = (name: string, team: string) =>
  `${name} kann danach Personen ohne Team in „${team}“ aufnehmen, Personen aus „${team}“ nehmen, ihnen eine Kontingentstufe zuweisen und den KI-Champion des Teams festlegen. Das Teamkontingent, andere Teams und das KI-Cockpit bleiben ${name} verschlossen.`;
/** Satz (gelb) vor „Team-Admin entfernen“. */
export const teamAdminEntfernenSatz = (name: string, team: string) => `${name} kann „${team}“ danach nicht mehr verwalten. Im Team bleibt ${name}.`;

/** Werteliste „Teamkontingent“: der Wert je Monat, ohne Teamkontingent oder ohne Bezug. */
export function teamkontingentWert(zeile: Pick<TeamZeile, 'teamkontingentProzent' | 'teamkontingentOhneBezug'>): string {
  if (zeile.teamkontingentOhneBezug) return TEAMS_TEXTE.ohneBezugSatz;
  return zeile.teamkontingentProzent === null ? TEAMS_TEXTE.ohneTeamkontingent : `${prozent(zeile.teamkontingentProzent)} des Kontingents je Monat`;
}
/** Ohne Teamkontingent nur der Text „In {Monat} verwendet: {q} % des Kontingents“. */
export const verwendetImMonat = (monat: string, anteil: Anteil) => `In ${monat} verwendet: ${anteilText(anteil)} des Kontingents`;
export const verwendetLabel = (monat: string) => `In ${monat} verwendet`;
export const vomTeamkontingent = (anteil: Anteil) => `${anteilText(anteil)} des Teamkontingents`;

/**
 * Satz vor „Teamkontingent speichern“: gelb, wenn der neue Wert unter dem schon Verwendeten liegt und „Neue Recherchen sperren“
 * gilt; sonst als Info „Gilt ab sofort für alle {n} Personen im Team.“ Ohne neuen Wert (leer, ohne Teamkontingent) sperrt nichts.
 */
export function speichernSatz(lage: { neu: number | null; modus: Modus; verwendet: Anteil | null; personen: number; monat: string }): { gelb: boolean; text: string } {
  const alle = lage.personen === 1 ? '1 Person' : `alle ${lage.personen} Personen`;
  if (lage.neu !== null && lage.modus === 'HARD' && lage.verwendet && lage.neu < lage.verwendet.prozent)
    return { gelb: true, text: `Das Team hat in ${lage.monat} schon ${anteilText(lage.verwendet)} des Kontingents verwendet. Mit ${prozent(lage.neu)} sind neue Recherchen für ${alle} im Team sofort gesperrt.` };
  return { gelb: false, text: `Gilt ab sofort für ${alle} im Team.` };
}
/** Der gespeicherte Wert im Feld, de-AT mit Komma („12,5“); ohne Teamkontingent leer. */
export const feldWert = (wert: number | null) => (wert === null ? '' : String(wert).replace('.', ','));

/** Dialog „Team löschen“: Titel und Satz (gelb). */
export function loeschenDialog(name: string, personen: number): { titel: string; satz: string } {
  const wer = personen === 1 ? '1 Person gehört' : `${personen} Personen gehören`;
  return { titel: `Team „${name}“ löschen?`, satz: `${wer} danach zu keinem eigenen Team. Das Teamkontingent entfällt; es gilt nur noch das Kontingent der Firma. Die bisherige Nutzung bleibt in der Auswertung unter „Gelöschte Teams“. Löschen lässt sich nicht rückgängig machen.` };
}

// ---- „Alle Mitglieder“ (1.6) ----

export const standardBeschreibung = (personen: number) =>
  `${personen === 1 ? 'Zu diesem Team gehört automatisch 1 Person' : `Zu diesem Team gehören automatisch alle ${personen} Personen`} Ihrer Firma.`;
/** F-24: was die Marke „Standard“ bedeutet, im Tooltip hinter ihr. */
export const STANDARD_TIPP = 'Das Standardteam lässt sich nicht umbenennen und nicht löschen.';
export const vorgabeText = (vorgabeProzent: number | null) => (vorgabeProzent === null ? TEAMS_TEXTE.keineVorgabe : TEAMS_TEXTE.vorgabeWert(prozent(vorgabeProzent)));

// ---- „Mein Team“ (1.7, PF-806) ----

/** Die Seite „Mein Team“ in „Meine Einstellungen“, wörtlich nach BAU-TEAMS.md 1.7; der Seitentitel steht in seiten.ts. */
export const MEIN_TEAM_TEXTE = {
  titel: 'Mein Team',
  laden: 'Die Angaben werden geladen …',
  keinTeam: 'Sie gehören zu keinem eigenen Team.',
  zurueckZumZugang: 'Zurück zu „Mein Zugang“',
  personenImTeam: 'Personen im Team',
  teamAdmins: 'Team-Admins',
  keine: 'keine',
  kiChampion: 'KI-Champion',
  nichtFestgelegt: 'nicht festgelegt',
  zusatzFirma: 'für die ganze Firma',
  balkenTitel: 'Kontingent Ihres Teams',
  modusSatz: { HARD: 'Ist es aufgebraucht, sind neue Recherchen für alle im Team gesperrt, bis es neu beginnt oder die Verwaltung Ihrer Firma es erhöht.',
    SOFT: 'Ist es aufgebraucht, sind weitere Recherchen erlaubt und werden gezählt.' } as Record<Modus, string>,
  // Seit Team-Admins Kontingentstufen zuweisen (PF-812): „…, weisen Kontingentstufen zu …“ (BAU-TEAMS.md 1.7; PF-812-nach).
  teamAdminSatz: 'Als Team-Admin nehmen Sie Personen ohne Team auf, nehmen Personen aus dem Team, weisen Kontingentstufen zu und legen den KI-Champion fest.',
} as const;
/** „Sie gehören zum Team „{Team}“ der Firma {Firma}.“ */
export const meinTeamBeschreibung = (team: string, firma: string) => `Sie gehören zum Team „${team}“ der Firma ${firma}.`;
/** „Team-Admins“: die Namen mit Komma, sonst „keine“. */
export const teamAdminsText = (namen: readonly string[]) => (namen.length ? namen.join(', ') : MEIN_TEAM_TEXTE.keine);
/** Der KI-Champion mit dem Zusatz „für die ganze Firma“, wenn die Angabe von der KI-Verantwortlichen der Firma kommt. */
export const kiChampionName = (champion: { name: string; quelle: 'TEAM' | 'FIRMA' }) =>
  champion.quelle === 'FIRMA' ? `${champion.name} (${MEIN_TEAM_TEXTE.zusatzFirma})` : champion.name;
/** Rechts am Balken: „{q} % verwendet“. */
export const teamVerwendet = (anteil: Anteil) => `${anteilText(anteil)} verwendet`;
/** „Beginnt am 1. {Monat} neu“ aus dem Neubeginn des Servers (MeinTeam.teamkontingent.beginntNeuAm), Monat in Wien. */
export const beginntNeuAm = (iso: string) => `Beginnt am 1. ${MONAT.format(new Date(iso))} neu`;

// ---- Teambalken auf „Nutzung“ und Fenster „Mehr für …“ (1.9, PF-806-2) ----

/** Titel des Teambalkens unter dem eigenen Balken auf „Nutzung“. */
export const teamBalkenTitel = (team: string) => `${MEIN_TEAM_TEXTE.balkenTitel} „${team}“`;
/** Satz (gelb) vor „Mehr geben“, wenn das Teamkontingent der Person aufgebraucht und gesperrt ist; dazu die Linkzeile. */
export const mehrTeamSatz = (name: string, team: string) =>
  `${name} gehört zum Team „${team}“. Dessen Teamkontingent ist für diesen Monat aufgebraucht; mehr für ${name} allein hilft erst, wenn das Teamkontingent erhöht wird.`;
export const TEAMKONTINGENT_AENDERN = 'Teamkontingent ändern';

// ---- Kontingentstufen auf der Teamseite und in „Mein Team“ (WB-11, PF-812) ----

/** SPEC-WELLE-B WB-11, Absatz „Teamseite und „Mein Team““, wörtlich. */
export const STUFEN_TEXTE = {
  auswahl: 'Kontingentstufe',
  vorgabe: 'Vorgabe der Firma',
  speichern: 'Kontingentstufe speichern',
  alleAuswaehlen: 'Alle auswählen',
  info: 'Gilt ab sofort für diesen Monat und die folgenden. Das Teamkontingent und das Kontingent der Firma gelten weiter.',
  keineVor: 'Es gibt noch keine Kontingentstufen. Die Verwaltung Ihrer Firma legt sie unter ',
  keineLink: 'Kontingent',
  keineNach: ' an.',
} as const;
/** „Es gibt noch keine Kontingentstufen. Die Verwaltung Ihrer Firma legt sie unter „Kontingent“ an.“ */
export const keineStufenSatz = () => `${STUFEN_TEXTE.keineVor}„${STUFEN_TEXTE.keineLink}“${STUFEN_TEXTE.keineNach}`;
/** „{n} Personen ausgewählt“ (1: „1 Person ausgewählt“). */
export const ausgewaehlt = (anzahl: number) => `${anzahl === 1 ? '1 Person' : `${anzahl} Personen`} ausgewählt`;
/** Eine Stufe in der Auswahl: „{Name} ({p} %)“; ohne Kontingent der Firma nur der Name. */
export const stufeOption = (stufe: { name: string; grenzeProzent: number | null }) =>
  stufe.grenzeProzent === null ? stufe.name : `${stufe.name} (${prozent(stufe.grenzeProzent)})`;
/** „Die Kontingentstufe ist für {n} Personen gespeichert.“ */
export const stufeGespeichert = (anzahl: number) => `Die Kontingentstufe ist für ${anzahl === 1 ? '1 Person' : `${anzahl} Personen`} gespeichert.`;
/** Auswahlfeld je Zeile, für Bildschirmleser. */
export const personAuswaehlen = (name: string) => `${name} auswählen`;
